import type { CustomIconProps } from '../types';

const Tag = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            fill="#C61B36"
            fillRule="evenodd"
            d="m10.915 5.687-5.228 5.228-4.602-4.602 5.228-5.228 4.458.144.144 4.458ZM5.546.317c.212-.211.503-.326.802-.316l4.458.143c.572.019 1.031.478 1.05 1.05l.143 4.458c.01.3-.105.59-.317.802l-5.228 5.228a1.085 1.085 0 0 1-1.534 0L.318 7.08a1.085 1.085 0 0 1 0-1.534L5.546.318Z"
            clipRule="evenodd"
        />
        <circle
            cx="8.885"
            cy="3.143"
            r=".585"
            fill="#C61B36"
            stroke="#C61B36"
            transform="rotate(45 8.885 3.143)"
        />
    </svg>
);

export default Tag;
